module.exports = __webpack_public_path__ + "static/media/test2_3.8f28fe7e.png";